import type { BiomeType } from '../model/gamestate/types';

export type TerrainTextureKey = string;

export interface TerrainBiomeDefinition {
  readonly id: BiomeType;
  readonly label: string;
  readonly previewPath: string;
}

export const TERRAIN_TEXTURE_PATHS: Readonly<Record<string, string>> = {
  grass: '/visual-assets/terrain/grass.png',
  sand: '/visual-assets/terrain/sand.png',
  water: '/visual-assets/terrain/water.png',
  dirt: '/visual-assets/terrain/dirt.png',
  grassy_dirt: '/visual-assets/terrain/grassy_dirt.png',
  meadow_dirt: '/visual-assets/terrain/meadow_dirt.svg',
  soft_grass: '/visual-assets/terrain/soft_grass.svg',
  brick: '/visual-assets/terrain/brick.png',
  brick2: '/visual-assets/terrain/brick2.png',
  cobblestone_path: '/visual-assets/terrain/cobblestone_path.svg',
  realistic_grass: '/visual-assets/terrain/haunted_forest_grass.png',
  realistic_grass2: '/visual-assets/terrain/haunted_forest_grass2.png',
  realistic_floor: '/visual-assets/terrain/floor.png',
  realistic_water: '/visual-assets/terrain/haunted_forest_bog_water.png',
  realistic_dirt: '/visual-assets/terrain/haunted_forest_dirt.png',
  floor: '/visual-assets/terrain/floor.png',
};

export const TERRAIN_BIOME_DEFINITIONS: readonly TerrainBiomeDefinition[] = [
  { id: 'grass', label: 'Grass', previewPath: TERRAIN_TEXTURE_PATHS.grass },
  { id: 'sand', label: 'Sand', previewPath: TERRAIN_TEXTURE_PATHS.sand },
  { id: 'water', label: 'Water', previewPath: TERRAIN_TEXTURE_PATHS.water },
  { id: 'dirt', label: 'Dirt', previewPath: TERRAIN_TEXTURE_PATHS.dirt },
  { id: 'grassy_dirt', label: 'Grassy Dirt', previewPath: TERRAIN_TEXTURE_PATHS.grassy_dirt },
  { id: 'meadow_dirt', label: 'Meadow Dirt', previewPath: TERRAIN_TEXTURE_PATHS.meadow_dirt },
  { id: 'soft_grass', label: 'Soft Grass', previewPath: TERRAIN_TEXTURE_PATHS.soft_grass },
  { id: 'brick', label: 'Brick', previewPath: TERRAIN_TEXTURE_PATHS.brick },
  { id: 'brick2', label: 'Brick 2', previewPath: TERRAIN_TEXTURE_PATHS.brick2 },
  { id: 'realistic_grass', label: 'Haunted Grass', previewPath: TERRAIN_TEXTURE_PATHS.realistic_grass },
  { id: 'realistic_grass2', label: 'Haunted Grass Pale', previewPath: TERRAIN_TEXTURE_PATHS.realistic_grass2 },
  { id: 'realistic_dirt', label: 'Haunted Dirt', previewPath: TERRAIN_TEXTURE_PATHS.realistic_dirt },
  { id: 'realistic_water', label: 'Bog Water', previewPath: TERRAIN_TEXTURE_PATHS.realistic_water },
  { id: 'realistic_floor', label: 'Stone', previewPath: TERRAIN_TEXTURE_PATHS.floor },
  { id: 'cobblestone_path', label: 'Cobblestone Path', previewPath: TERRAIN_TEXTURE_PATHS.cobblestone_path },
];

const terrainBiomeDefinitionsById = new Map(
  TERRAIN_BIOME_DEFINITIONS.map((definition) => [definition.id, definition] as const)
);

export function getTerrainBiomeDefinition(biome: BiomeType): TerrainBiomeDefinition | null {
  return terrainBiomeDefinitionsById.get(biome) ?? null;
}

export function getTerrainTexturePath(key: TerrainTextureKey): string | null {
  return TERRAIN_TEXTURE_PATHS[key] ?? null;
}
